import { getApp } from "firebase/app";
import { FirebaseAppName } from "./FirebaseAppName";

export function getFirebaseApp() {
  return getApp(FirebaseAppName);
}
